import { gql } from '@apollo/client';

/**
 * What the household holds today, in money.
 *
 * A model portfolio only ever says what share of a household a security should
 * be, so this is the balance those shares are read against when the review
 * shows them as amounts rather than weights.
 */
export const FETCH_HOUSEHOLD_MARKET_VALUE = gql`
  query fetchHouseholdMarketValue($clientGroupId: SafeString!) {
    fetchClientGroup(input: { clientGroupId: $clientGroupId }) {
      clientGroup {
        id: stringId
        statistics {
          marketValueCents
          currency
        }
      }
    }
  }
`;
